import { TipoElementoEnum } from "../enum/tipo-elemento-enum";
import { MessaggioErroreDTO } from "./messaggio-erroreDTO";

export class DettaglioErroreDTO {
  idElemento: string;
  oggetto: string;
  tipoElementoEnum: TipoElementoEnum;
  messaggioErrore: MessaggioErroreDTO[];
}
